import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useGlobalScroll from "../../../../hooks/useGlobalScroll";
import { EditOptionContainer } from "../styled/setting";
import { BsChevronLeft } from "react-icons/bs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import axios from "axios";

const EditOption = ({ selection, setSelection, getCart }) => {
  const { cmpnyNo } = useParams();
  const [options, setOptions] = useState([]);
  const [selectOption, setSelectOption] = useState({});

  useEffect(() => {
    if (!selection) return;
    getOption();
  }, [selection]);

  const getOption = async () => {
    const url = "/erp/option/get";
    const body = { vendorProductId: selection.vendorProductId, admin: false };
    try {
      const res = await axios.post(url, body);
      setOptions(res.data);
      if (res.data) {
        formatOption(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatOption = (productOption) => {
    const init = {};
    productOption.forEach((optionGroup) => {
      const matched = optionGroup.options.find((opt) =>
        selection.options.some((selOpt) => selOpt.optionId === opt.id),
      );
      if (matched) {
        init[optionGroup.id] = matched.id;
      }
    });
    setSelectOption(init);
  };

  // 옵션 선택 변경 핸들러
  const handleOptionChange = (optionGroupId, optionId) => {
    setSelectOption((prevState) => ({
      ...prevState,
      [optionGroupId]: optionId,
    }));
  };

  // 확인 버튼 클릭
  const handleSubmit = async () => {
    if (!validationCheck()) return;

    const updatedOptions = Object.entries(selectOption).map(([groupId, optionId]) => {
      const group = options.find((g) => g.id === parseInt(groupId));
      const option = group?.options.find((opt) => opt.id === parseInt(optionId));

      const originGroupOption = selection.options.find((o) =>
        group?.options.some((opt) => Number(opt.id) === Number(o.optionId)),
      );

      return {
        id: originGroupOption?.id || null,
        optionId: option?.id,
        qty: option?.consumeCount || 1,
        name: option?.value || "",
        price: option?.addPrice || 0,
      };
    });

    const updatedProduct = {
      ...selection,
      options: updatedOptions,
    };

    await updateCart(updatedProduct);
    setSelection(null);
  };

  const validationCheck = () => {
    for (const group of options) {
      if (group.isRequired && !selectOption[group.id]) {
        toast.error(`옵션 ${chooseParticle(group.name, "을를")} 선택해주세요.`);
        return false;
      }
    }
    return true;
  };

  const isSameOptions = (a = [], b = []) => {
    if (a.length !== b.length) return false;
    const sa = [...a].sort((x, y) => x.optionId - y.optionId);
    const sb = [...b].sort((x, y) => x.optionId - y.optionId);
    return sa.every((x, i) => x.optionId === sb[i].optionId && (x.qty ?? 1) === (sb[i].qty ?? 1));
  };

  const updateCart = (product) => {
    try {
      const raw = localStorage.getItem(`mbCart:${cmpnyNo}`);
      const current = JSON.parse(raw || "[]");
      const cart = Array.isArray(current) ? [...current] : [];

      if (selection.index !== undefined) {
        cart.splice(selection.index, 1);
      }

      // 동일한 상품 + 동일한 옵션이 있는지
      const foundIndex = cart.findIndex(
        (it) =>
          it.vendorProductId === product.vendorProductId &&
          isSameOptions(it.options, product.options),
      );

      if (foundIndex !== -1) {
        cart[foundIndex].quantity += product.quantity || 1;
      } else {
        const updatedProduct = {
          ...product,
          productName: product.productName || "",
          productPrice: product.productPrice || 0,
          productImageUrl: product.productImageUrl || "",
          checked: product.checked !== undefined ? product.checked : true,
        };
        cart.push(updatedProduct);
      }

      localStorage.setItem(`mbCart:${cmpnyNo}`, JSON.stringify(cart));
      getCart();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <EditOptionContainer>
      <ul>
        {options.map((optionGroup) => (
          <li>
            <div className="tit">
              {optionGroup.name}
              {optionGroup.isRequired && ` (필수선택)`}
            </div>
            <select
              name={`optionGroup-${optionGroup.id}`}
              value={selectOption[optionGroup.id] || ""}
              onChange={(e) => handleOptionChange(optionGroup.id, e.target.value)}>
              <option value="">{optionGroup.name}</option>
              {optionGroup.options.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.value} (+{formatNumber(option.addPrice)}원)
                </option>
              ))}
            </select>
          </li>
        ))}
      </ul>
      <button className="submit" onClick={handleSubmit}>
        확인
      </button>
    </EditOptionContainer>
  );
};

export default EditOption;
